import { Link, useLocation } from "react-router-dom";
import Button from "../../Shared/Button/Button";

const ReviewButtons = () => {
  const location = useLocation();
  const path = location.pathname;

  return (
    <div className="mt-[30px] flex justify-end gap-2.5  pl-32">
      <Link to="/user/reviews-pending" className="block w-full">
        <Button
          text="Pending Reviews"
          variant={path === "/user/reviews-pending" ? "primary" : "outline"}
          className={`!w-full text-xl ${
            path === "/user/reviews-pending" ? "" : "!text-darkGreen"
          }`}
        />
      </Link>
      <Link to="/user/reviews-receieved" className="block w-full">
        <Button
          text="Receieved Reviews"
          variant={path === "/user/reviews-receieved" ? "primary" : "outline"}
          className={`!w-full text-xl ${
            path === "/user/reviews-receieved" ? "" : "!text-darkGreen"
          }`}
        />
      </Link>
      <Link to="/user/reviews-given" className="block w-full">
        <Button
          text="Reviews Given"
          variant={path === "/user/reviews-given" ? "primary" : "outline"}
          className={`!w-full text-xl ${
            path === "/user/reviews-given" ? "" : "!text-darkGreen"
          }`}
        />
      </Link>
    </div>
  );
};

export default ReviewButtons;
